var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusModeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#4B33A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.504 15.475V13.5C28.504 11.294 26.71 9.5 24.504 9.5H14.504C12.298 9.5 10.504 11.294 10.504 13.5V15.498L10.428 15.502C10.1758 15.5202 9.93986 15.6333 9.76768 15.8184C9.59549 16.0036 9.49985 16.2471 9.5 16.5V18.5C9.5 18.7652 9.60536 19.0196 9.79289 19.2071C9.98043 19.3946 10.2348 19.5 10.5 19.5H10.504V25.5C10.504 26.235 10.907 26.872 11.5 27.22V28.5C11.5 28.7652 11.6054 29.0196 11.7929 29.2071C11.9804 29.3946 12.2348 29.5 12.5 29.5H13.5C13.7652 29.5 14.0196 29.3946 14.2071 29.2071C14.3946 29.0196 14.5 28.7652 14.5 28.5V27.5H24.5V28.5C24.5 28.7652 24.6054 29.0196 24.7929 29.2071C24.9804 29.3946 25.2348 29.5 25.5 29.5H26.5C26.7652 29.5 27.0196 29.3946 27.2071 29.2071C27.3946 29.0196 27.5 28.7652 27.5 28.5V27.224C27.804 27.0501 28.0569 26.7992 28.2331 26.4966C28.4094 26.1939 28.5028 25.8502 28.504 25.5V19.5C28.7692 19.5 29.0236 19.3946 29.2111 19.2071C29.3986 19.0196 29.504 18.7652 29.504 18.5V16.562C29.5155 16.4068 29.4909 16.2511 29.432 16.107C29.229 15.62 28.797 15.503 28.504 15.475ZM26.506 25.5H12.504V20.5H26.505L26.506 25.5ZM18.504 14.5V18.5H12.504V14.5H18.504ZM26.504 14.5V18.5H20.504V14.5H26.504ZM14.504 11.5H24.504C25.24 11.5 25.879 11.905 26.226 12.5H12.782C13.129 11.905 13.768 11.5 14.504 11.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.5C15.8284 24.5 16.5 23.8284 16.5 23C16.5 22.1716 15.8284 21.5 15 21.5C14.1716 21.5 13.5 22.1716 13.5 23C13.5 23.8284 14.1716 24.5 15 24.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.5C24.8284 24.5 25.5 23.8284 25.5 23C25.5 22.1716 24.8284 21.5 24 21.5C23.1716 21.5 22.5 22.1716 22.5 23C22.5 23.8284 23.1716 24.5 24 24.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusModeSelected);
export default __webpack_public_path__ + "static/media/busModeSelected.9b8f0ba1374b0c045d2d90497490adf6.svg";
export { ForwardRef as ReactComponent };